// Javascript functions  and objects that need to be accessible from
// libproduct_donate.liquid
//
// Note: this is using CommonJS instead of ES6+ since this is being interpreted
// directly by the js interpreter instead of being compiled by webpack. This is
// done since these functions and objects need to be accessible from a
// .liquid file.
//
// In order for this file to pass linting, the global directive is needed at the
// top, and module.exports is needed at the end of this file.

export const SHOPIFY_DATA = {
    product: [],
    first_productid: '',
};

// Product is an object that contains the following attributes:
// * id
// * name
// * category_name
// * sku
// * variants
// * quantity
// * vendor
// * global_category
export function save_sgproduct_datalayer(product, position, listname) {
    SHOPIFY_DATA.product.push({
        product,
        position,
        listname,
    });
}

export function save_sgproduct_id(product_id) {
    SHOPIFY_DATA.first_productid = product_id;
}
